import { Currency } from '~/shared';
import donate from '../icons/currency_donate.svg';
import ruble from '../icons/currency_ruble.svg';
import rubleRound from '../icons/currency_ruble_round.svg';

export type CurrencyIconVariant = 'default' | 'rounded';
export const DEFAULT_VARIANT: CurrencyIconVariant = 'default';

export const CurrencyIconImage: Record<
	Currency,
	Partial<Record<CurrencyIconVariant, string>>
> = {
	[Currency.Ruble]: {
		default: ruble,
		rounded: rubleRound,
	},
	[Currency.Donate]: {
		rounded: donate,
	},
};

export const PRESET_SIZES = {
	sm: { w: 14, h: 14 },
	md: { w: 16, h: 16 },
	lg: { w: 20, h: 20 },
} as const;

export const CONTENTS = [Currency.Ruble, Currency.Donate] as const;
